import { FuelNameEnum } from 'common/enums';

export const desiredKeysOrderForConsumptionChart = {
  sumFuelByYear: {
    value: [FuelNameEnum.Electricity, FuelNameEnum.Petrol, FuelNameEnum.Diesel],
    colors: ['green', 'gold', 'blue']
  }
};
